export default __webpack_public_path__ + "images/6de029e578804a108636e185058cfc0c-YGP_citybrowseheader_Generic_791x488px@2x.webp";